import {HeroHeader} from "@/components/HeroHeader.tsx";
import PodcastIframe from "@/components/PodcastIframe.tsx";
import {MetaTags} from "@/hooks/MetaTags.tsx";

const IFRAME_SRC = "https://iframe.iono.fm/chan/4521?layout=modern";

export default function PodcastsPage() {
    return (
        <>
            <MetaTags
                title={"Kosmos 94.1 - Gesprekke"}
                description={"Luister na ons mees onlangse gesprekke en onderhoude met interessante gaste."}
                url={"/potgooi/gesprekke"}
            />

            <HeroHeader
                title="Gesprekke"
                subtitle="Luister na ons mees onlangse gesprekke en onderhoude met interessante gaste."
                imageAlt="Gesprekke"
            />

            <PodcastIframe
                src={IFRAME_SRC}
            />
        </>
    );
}
